import React, { Component, PropTypes } from 'react'
import { browserHistory, Link } from 'react-router'
import { FormattedNumber } from '../misc'
import { getNumericValueOf, getProperty, nl2br, DATE_FORMAT } from '../utils'

import { Loading } from '../misc'
import Header from '../header'
import InvoiceForm from '../../containers/invoice_form'
import { Button, Label } from '../ui'
import { storage } from '../../utils'

class Invoice extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    onboarding_complete: PropTypes.bool.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        jobs: PropTypes.object.isRequired,
        jobsActions: PropTypes.object.isRequired,
        personal: PropTypes.shape({
            data: PropTypes.shape({
                stripe_connect_account_id: PropTypes.string,
            }),
        }).isRequired,
        personalActions: PropTypes.shape({
            loadPersonal: PropTypes.func.isRequired,
        }).isRequired,
        routeParams: PropTypes.object.isRequired,
    }

    componentDidMount() {
        this.props.jobsActions.clearJob()
        this.props.jobsActions.loadJob(this.props.account.user.crew.uuid, this.props.routeParams.job)

        // If we have no personal data, load it.
        if (! this.props.personal.data) {
            this.props.personalActions.loadPersonal(this.props.account.user.crew.uuid)
        }
    }

    _downloadPDF = () => {
        browserHistory.push(this.jobs.job.invoice_obj.pdf)
    }

    _goToJobsList = () => {
        browserHistory.push('/jobs')
    }

    render() {
        const job = this.props.jobs.job

        // if the job hasn't loaded in yet, show the loading page
        if (! (job && this.props.personal.data)) {
            return (
                <div>
                    <Header title="Invoice" />

                    <div className="content">
                        <div className="content__inner">
                            <Loading />
                        </div>
                    </div>
                </div>
            )
        }

        // if the job has no invoice, show the "create invoice" form
        if (! job.invoice_obj) {
            // However, if the user has not got set up stripe, interrupt and point them towards the
            // setup for such.
            // if (! this.props.personal.data.stripe_connect_account_id) {
            //     return (
            //         <div>
            //             <Header title="Invoice" />

            //             <div className="content">
            //                 <div className="content__inner">
            //                     <div className="alert alert--error text-strong">
            //                         <p>
            //                             You need to enter your banking details to set up a payment account
            //                             in order to raise invoices.
            //                         </p>

            //                         <Link className="btn btn--delete" to="/banking/edit">Go to the Banking page</Link>
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     )
            // }

            return <InvoiceForm />
        }

        // otherwise, we have a job and an invoice
        const invoice = job.invoice_obj

        const tokenSuffix = `?token=${ storage.getItem('authToken') }`

        return (
            <div>
                <Header title="Invoice" />

                <div className="content">
                    { this.props.account.user.crew.onboarding_complete || (
                        <div className="content__inner">
                            <div className="alert alert--error text-strong">
                                Please fully complete your profile to be considered for the maximum
                                number of job opportunities.
                            </div>
                        </div>
                    ) }

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Job Details
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <div className="grid grid--break-mobile">
                                    <div className="grid grid__span-6">
                                        <p>Invoice date: { invoice.created_date.format(DATE_FORMAT) }</p>
                                        <p>
                                            { invoice.first_name } { invoice.last_name }<br />
                                            { invoice.email }<br />
                                            { invoice.mobile_phone }
                                        </p>
                                    </div>
                                    <div className="grid grid__span-6">
                                        <p>Job number: { job.job_number }</p>
                                        <p>Job date: { job.job_date.format(DATE_FORMAT) }</p>
                                        <p>Job client: { getProperty(job.client_obj, 'name', 'N/A') }</p>
                                        <p>Job crew: { getProperty(job.crew_type_obj, 'name', 'N/A') }</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Job Billing & Expenses
                                </div>
                            </div>
                            <div className="box__content">
                                <table className="table">
                                    <thead>
                                        <tr className="table-row">
                                            <th className="table-head-cell">Description</th>
                                            <th className="table-head-cell">Receipt/notes</th>
                                            <th className="table-head-cell">Total Price</th>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr className="table-row">
                                            <td className="table-cell" />
                                            <th className="table-head-cell text-right">
                                                Total Job Rate
                                            </th>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={
                                                        getNumericValueOf(invoice.labour) +
                                                        getNumericValueOf(invoice.owned_gear) +
                                                        getNumericValueOf(job.overtime)
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <td className="table-cell" />
                                            <th className="table-head-cell text-right">
                                                Total Reimbursements
                                            </th>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={
                                                        getNumericValueOf(invoice.rented_gear) +
                                                        getNumericValueOf(invoice.hard_drive) +
                                                        getNumericValueOf(invoice.shipping) +
                                                        getNumericValueOf(invoice.gas) +
                                                        getNumericValueOf(invoice.mileage) +
                                                        getNumericValueOf(invoice.parking) +
                                                        getNumericValueOf(invoice.taxi) +
                                                        getNumericValueOf(invoice.meals) +
                                                        getNumericValueOf(invoice.misc)
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <td className="table-cell" />
                                            <th className="table-head-cell text-right">
                                                Grand Total Owed
                                            </th>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.total) }
                                                />
                                            </td>
                                        </tr>
                                    </tfoot>

                                    <tbody>
                                        <tr className="table-row">
                                            <td
                                                className="table-cell"
                                                colSpan="3"
                                                style={{ fontWeight: 'bold', textTransform: 'uppercase' }}
                                            >
                                                Job Rate
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Labor</Label>
                                            </td>
                                            <td className="table-cell" />
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.labour) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Owned gear</Label>
                                            </td>
                                            <td className="table-cell">
                                                { invoice.owned_gear_desc }
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.owned_gear) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Overtime</Label>
                                            </td>
                                            <td className="table-cell" />
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(job.overtime) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td
                                                className="table-cell"
                                                colSpan="3"
                                                style={{ fontWeight: 'bold', textTransform: 'uppercase' }}
                                            >
                                                Reimbursable Expenses
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Rented gear</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.rented_gear', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.rented_gear) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Hard drive</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.hard_drive', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.hard_drive) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Shipping</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.shipping', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.shipping) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Gas</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.gas', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.gas) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Mileage</Label>
                                            </td>
                                            <td className="table-cell">
                                                { invoice.mileage_desc }
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.mileage) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Parking</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.parking', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.parking) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Taxi</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.taxi', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.taxi) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Meals</Label>
                                            </td>
                                            <td className="table-cell">
                                                <ul>
                                                    {
                                                        getProperty(invoice, 'receipts.meals', []).map((item) => (
                                                            <li key={ item.uuid }>
                                                                <a
                                                                    href={ `${ item.file }${ tokenSuffix }` }
                                                                    target="_blank"
                                                                >
                                                                    { item.name }
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.meals) }
                                                />
                                            </td>
                                        </tr>

                                        <tr className="table-row">
                                            <td className="table-cell">
                                                <Label>Misc Expenses</Label>
                                            </td>
                                            <td className="table-cell">
                                                { invoice.misc_desc }
                                            </td>
                                            <td className="table-cell">
                                                <FormattedNumber
                                                    currency="USD"
                                                    style="currency"
                                                    value={ getNumericValueOf(invoice.misc) }
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="grid grid--break-mobile">
                            <div className="grid grid__span-6">
                                <div className="box">
                                    <div className="box__header">
                                        <div className="box__title">
                                            Notes/comments
                                        </div>
                                    </div>
                                    <div className="box__content box__content--padded">
                                        { nl2br(invoice.notes) }
                                    </div>
                                </div>
                            </div>

                            { Boolean(getProperty(invoice, 'receipts.additional', []).length) &&
                                <div className="grid grid__span-6">
                                    <div className="box">
                                        <div className="box__header">
                                            <div className="box__title">
                                                Additional attachments and receipts
                                            </div>
                                        </div>
                                        <div className="box__content box__content--padded">
                                            <ul>
                                                {
                                                    getProperty(invoice, 'receipts.additional', []).map((item) => (
                                                        <li key={ item.uuid }>
                                                            <a
                                                                href={ `${ item.file }${ tokenSuffix }` }
                                                                target="_blank"
                                                            >
                                                                { item.name }
                                                            </a>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Actions
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <div className="grid grid--break-mobile">
                                    <div className="grid grid__span-6">
                                        Pay date: { job.pay_date.format(DATE_FORMAT) }
                                    </div>
                                    <div className="grid grid__span-6">
                                        <a
                                            className="btn btn--primary"
                                            href={ `${ invoice.pdf_url }${ tokenSuffix }` }
                                        >
                                            Download PDF
                                        </a>
                                    </div>
                                </div>

                                <Button onClick={ this._goToJobsList }>Back to Job List</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Invoice



// WEBPACK FOOTER //
// ./app/components/jobs/invoice.js